import { css } from 'styled-components';

export const modalButtonMixin = css`
  width: ${({ theme: { variables } }) => variables.modalDialogButtonWith};
  min-width: ${({ theme: { variables } }) => variables.modalDialogButtonWith};
`;
